<template>
  <v-container class="pa-10">
    <scroll></scroll>
    <recharge-menu></recharge-menu>
    <banner></banner>
    <commissions></commissions>
    <quick-recharge></quick-recharge>
  </v-container>
</template>

<script>
import Banner from "../components/index/Banner.vue";
import Commissions from "../components/index/Commissions.vue";
import QuickRecharge from "../components/index/QuickRecharge.vue";
import RechargeMenu from "../components/index/RechargeMenu.vue";
import Scroll from "../components/index/Scroll.vue";

export default {
  components: { Banner, Commissions, Scroll, RechargeMenu, QuickRecharge },
};
</script>

<style>
</style>